import BaseServiceCrud from './BaseServiceCrud';

export default class VoucherCategoryService extends BaseServiceCrud {
    // Initializing important variables
    constructor() {
        super();
        this.path = 'voucher-category';
    }

    getCriteria(criteria) {
        return this.objToQueryString({
            locale: criteria.locale,
            name: criteria.name,
            first_result: criteria.firstResult,
            max_results: criteria.maxResults,
            sort_field: criteria.sortField,
            sort_asc: criteria.sortAsc,
        });
    }

    getCategories(locale) {
        return this.fetch(`${this.domain}/${this.path}/categories/${locale}`, {
            method: 'GET',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }
    removeVoucherCategory(id) {
        return this.fetch(`${this.domain}/${this.path}/${id}`, {
            method: 'DELETE',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    update(element) {
        // Get a token from api server using the fetch api
        return this.fetch(`${this.domain}/${this.path}/`, {
            method: 'PUT',
            body: JSON.stringify(element),
        }).then((res) => {
            return Promise.resolve(res);
        });
    }
}
